import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	title: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.title',
		defaultMessage: 'Advanced prompt',
		description: 'Describes an option to use Atlassian Intelligence to show a more advanced prompt',
	},
	description: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.description',
		defaultMessage: 'Specify task, instructions and rules',
		description: 'Description for the the Atlassian Intelligence "Advanced prompt".',
	},
	promptLabel: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptLabel',
		defaultMessage: 'Advanced prompt',
		description: 'Label text in the prompt input.',
	},
	taskLabel: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptBuilder.task.label',
		defaultMessage: 'Task',
		description: 'Label for the Task input in the prompt builder.',
	},
	taskPlaceholder: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptBuilder.task.placeholder',
		defaultMessage:
			'Create a brief overview of the impacts of climate change on polar bear populations, suitable for a high school science presentation.',
		description: 'Placeholder for the Task input in the prompt builder.',
	},
	taskHelperMessage: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptBuilder.task.helperMessage',
		defaultMessage: 'Describe what you want the AI to do',
		description: 'Helper message for the Task input in the prompt builder.',
	},
	taskRequired: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptBuilder.task.error.required',
		defaultMessage: 'Please provide task',
		description: 'Error message for the Task input in the prompt builder.',
	},
	instructionsLabel: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptBuilder.instructions.label',
		defaultMessage: 'Instructions',
		description: 'Label for the Instructions input in the prompt builder.',
	},
	instructionsPlaceholder: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptBuilder.instructions.placeholder',
		defaultMessage:
			'1. Start by introducing the context of climate change and its global significance.\n' +
			'2. Detail the specific ways in which rising temperatures affect polar bear habitats.\n' +
			'3. Include statistics or studies that demonstrate changes in polar bear population numbers over recent decades.\n' +
			'4. Conclude with potential solutions or actions that can be taken to protect polar bears.',
		description: 'Placeholder for the Instructions input in the prompt builder.',
	},
	instructionsHelperMessage: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptBuilder.instructions.helperMessage',
		defaultMessage: 'Provide step-by-step guidance on how the AI should complete the task',
		description: 'Helper message for the Instructions input in the prompt builder.',
	},
	rulesLabel: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptBuilder.rules.label',
		defaultMessage: 'Rules',
		description: 'Label for the Rules input in the prompt builder.',
	},
	rulesPlaceholder: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptBuilder.rules.placeholder',
		defaultMessage:
			'Use simple and clear language appropriate for high school students. Avoid using overly technical jargon or advanced scientific terms without explanations. Ensure that all included data is from reputable sources and is up-to-date.',
		description: 'Placeholder for the Rules input in the prompt builder.',
	},
	rulesHelperMessage: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptBuilder.rules.helperMessage',
		defaultMessage: 'Specify what to follow and what to avoid',
		description: 'Helper message for the Rules input in the prompt builder.',
	},
	toneLabel: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptBuilder.tone.label',
		defaultMessage: 'Tone',
		description: 'Label for the Tone input in the prompt builder.',
	},
	toneProfessional: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptBuilder.tone.option.professional',
		defaultMessage: 'Professional',
		description: 'Option for the Tone input in the prompt builder.',
	},
	toneEmpathetic: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptBuilder.tone.option.empathetic',
		defaultMessage: 'Empathetic',
		description: 'Option for the Tone input in the prompt builder.',
	},
	toneCasual: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptBuilder.tone.option.casual',
		defaultMessage: 'Casual',
		description: 'Option for the Tone input in the prompt builder.',
	},
	toneNeutral: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptBuilder.tone.option.neutral',
		defaultMessage: 'Neutral',
		description: 'Option for the Tone input in the prompt builder.',
	},
	toneEducational: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptBuilder.tone.option.educational',
		defaultMessage: 'Educational',
		description: 'Option for the Tone input in the prompt builder.',
	},
	creativityLabel: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptBuilder.creativity.label',
		defaultMessage: 'Creativity',
		description: 'Label for the Creativity input in the prompt builder.',
	},
	creativityLow: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptBuilder.creativity.option.low',
		defaultMessage: 'Low',
		description: 'Option for the Creativity input in the prompt builder.',
	},
	creativityMedium: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptBuilder.creativity.option.medium',
		defaultMessage: 'Medium',
		description: 'Option for the Creativity input in the prompt builder.',
	},
	creativityHigh: {
		id: 'fabric.editor.ai.config.item.advanced-prompt.promptBuilder.creativity.option.high',
		defaultMessage: 'High',
		description: 'Option for the Creativity input in the prompt builder.',
	},
});
